<template>
  <div class="propertysupervise">
    <div class="header">
      <div class="title">实时社区监管</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div class="position">
          <img :src="mobilepropertyoffice3" alt="" />
        </div>
      </div>

      <div class="right">
        实时监控管理中心，可启用远程监管，事前预警、事中控制、事后管理，发现问题随时随地快速安排相关工作，在线派单发布任务，提高物业工作效率。
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilepropertyoffice3 from "../../../../assets/product/mobilepropertyoffice3.png";

export default {
  setup() {
    return reactive({
      mobilepropertyoffice3: mobilepropertyoffice3,
    });
  },
};
</script>

<style scoped>
.propertysupervise {
  width: 100%;
  margin: 24px auto;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  margin-top: 16px;
  text-align: center;
}
.body .left .logo img {
  width: 332px;
  margin-right: 20px;
}
.body .left .position img {
  width: 238px;
}
.body .left .position img:nth-of-type(1) {
  left: 100%;
}
.body .left .position img:nth-of-type(2) {
  left: 125%;
  bottom: 0;
}
.body .left .position img:nth-of-type(3) {
  left: 150%;
  bottom: 0;
}
.body .right {
  width: 92vw;
  margin: 16px auto 0;
  font-size: 12px;
  color: #3d3d3d;
}
</style>
